import styled, { CSSObject } from 'styled-components';

interface ListStyledProps {
  sx?: CSSObject;
}

const ListStyled = styled.ul<ListStyledProps>(({ theme, sx }) => ({
  paddingLeft: theme.space[8],
  boxSizing: 'border-box',
  listStyle: 'none',
  ...sx,
}));

const TitleStyled = styled.span<ListStyledProps>(({ theme }) => ({
  marginLeft: theme.space[2],
  fontSize: theme.font.size.medium,
  fontWeight: theme.font.weight.bold,
}));

export { ListStyled, TitleStyled };
